import axios from "axios";
import CheckHttp from "@/asyncs/MyHttpCheck.js";
import {
    Notify
} from "vant";
import Env from "@/logics/Envs.js";

export default async function (taskId, data, remove) {
    try {
        const toSend = new FormData();
        toSend.append("taskId", taskId);
        toSend.append("json", JSON.stringify(data));
        toSend.append("remove", remove);
        const res = await axios.post(Env.apiPath + "setTaskSubmission", toSend);
        if (res.data.error) {
            Notify({
                type: "danger",
                message: res.data.error,
                duration: 5000
            });
            return false;
        }
        return true;
    } catch (err) {
        CheckHttp(err);
        return false;
    }
}